import { CardContent, type SxProps } from '@mui/material'
import { SafeImage } from 'shared/ui/atoms/safeImage'
import { BaseEventCard, type EventDTO } from '~entities/index'
import { Typography } from '~sharedUI'

export const HorizontalCard = ({
	info,
	isSmall = false,
	sx
}: {
	info: EventDTO | undefined
	isSmall?: boolean
	sx?: SxProps
}) => {
	return (
		<BaseEventCard info={info} sx={{ ...{ display: 'flex' }, ...sx }}>
			<SafeImage
				src={info?.picture}
				sx={{
					minWidth: isSmall ? '28%' : '53%'
				}}
			/>
			<CardContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-between',
					padding: '24px'
				}}
			>
				<Typography fontWeight='bold' lineHeight={'32px'} fontSize={'sm'}>
					{info?.name}
				</Typography>
				<Typography
					fontSize={'xs'}
					lineHeight={'24px'}
					fontWeight='bold'
					color='text.accent'
				>
					{info?.date}
				</Typography>
			</CardContent>
		</BaseEventCard>
	)
}
